import React from 'react';
import styled from 'styled-components';
import { darkLogoSrcSet, lightLogoSrcSet } from './SudoPlatformLogos';
const SudoPlatformLogoContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledImage = styled.img `
  display: block;
  width: ${(props) => `${props.width}px` ?? 'auto'};
  height: auto;
`;
export const SudoPlatformLogo = (props) => (React.createElement(SudoPlatformLogoContainer, { className: props.className },
    React.createElement(StyledImage, { srcSet: props.lightLogo ? lightLogoSrcSet : darkLogoSrcSet, width: props.width, alt: "sudo platform logo" })));
